export default "/build/frontend/fonts/vendor/@fontsource/inter/files/inter-cyrillic-ext-400-normal.woff?e89451624c6caf35687f19736625469b";